import React, { useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Container,
  Typography,
  Snackbar,
  Alert,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Checkbox,
  IconButton,
  MenuItem,
  Menu,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Pagination,
  PaginationItem,
  Grid,
  ListItem,
  ListItemText,
  List,
  CardContent,
  Card,
  Select,
  TextField
} from '@mui/material';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import Page from '../../components/Page';
import Iconify from 'src/components/Iconify';
import VisibilityIcon from '@mui/icons-material/Visibility'; // 👈 optional icon
import DownloadIcon from '@mui/icons-material/Download';

//icons
import Empty_Truck from '../../../src/asset/open-door.png';
import { api } from 'src/Api';
import { LoadingButton } from '@mui/lab';
import moment from 'moment';
import { NumericFormat } from 'react-number-format';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import { Delete as DeleteIcon, Upload as UploadIcon } from '@mui/icons-material';

export default function UploadDoc() {
  const navigate = useNavigate();
  const location = useLocation();
  const { shipmentDetail, type } = location.state || {};
  console.log('shipmentDetail: ', shipmentDetail);
  const userData = JSON.parse(localStorage.getItem('user'));

  const [trucksList, setTrucksList] = useState([]);
  const [documentTypeList, setDocumentTypeList] = useState([]);

  const [loading, setloading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = useState(1);

  const [openAlertModal, setOpenAlertModal] = useState(false);

  const [searchLoading, setsearchLoading] = useState(false);
  const [search, setsearch] = useState('');
  const [documentType, setDocumentType] = useState('');
  console.log('🚀 ~ UploadDoc ~ documentType:', documentType);

  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [selectedDocument, setSelectDocument] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    getDocumentType();
  }, []);

  useEffect(() => {
    if (search.length == 0) {
      trucksList.length = 0;
      getTruckList(page);
    }
  }, [search]);

  useEffect(() => {
    getTruckList(page);
  }, [page]);

  function getTruckList(page) {
    setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    search.length > 0 && queryParams.append('search', search);
    queryParams.append('entity_id', shipmentDetail?.id);
    page && queryParams.append('page', page);
    queryParams.append('type', type);

    fetch(`${api.get_documents}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setTrucksList(result.data);
          result?.count ? setpagesCount(Math.ceil(result?.count / 10)) : setpagesCount(1);
          setloading(false);
          setsearchLoading(false);
        } else {
          setTrucksList([]);
          setpagesCount(0);
          setloading(false);
          setsearchLoading(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloading(false);
        setsearchLoading(false);
      });
  }

  function getDocumentType() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.get_document_type, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setDocumentTypeList(result.data);
        } else {
          setDocumentTypeList([]);
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  }

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handlePageChange = (event, value) => {
    trucksList.length = 0;
    setPage(value);
    getTruckList(value);
  };

  const handleCloseAlert = () => {
    setOpenAlertModal(false);
    setSelectDocument(null);
  };

  const handleOpenUploadDialog = () => {
    setOpenUploadDialog(true);
  };

  const handleCloseUploadDialog = () => {
    setOpenUploadDialog(false);
    setSelectedFiles([]);
  };

  const handleFileChange = (event) => {
    setSelectedFiles([...selectedFiles, ...event.target.files]);
  };

  const handleRemoveFile = (index) => {
    const newFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(newFiles);
  };

  const handleSubmit = () => {
    // Handle file upload logic here
    handleUploadFile();
  };

  function handleUploadFile() {
    setLoadingUpload(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('url', selectedFiles[0]);
    formdata.append('entity_id', shipmentDetail?.id);
    formdata.append('name', selectedFiles[0].name);
    formdata.append('type', type);
    formdata.append('document_type_id', documentType);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.upload_document, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const response = JSON.parse(body);
        if (status === 200 || status === 201) {
          if (response.message == 'Import completed with some errors') {
            setSnackbarMessage(response.message);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
          }
          handleCloseUploadDialog();
          setSnackbarMessage(response.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          getTruckList(1);
        } else {
          setSnackbarMessage(response.error);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setLoadingUpload(false);
        setTimeout(() => {
          handleSnackbarClose();
        }, 2000);
      });
  }

  function handleDeleteDocument() {
    setDeleteLoading(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('id', selectedDocument);
    formdata.append('type', type);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.delete_document, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const response = JSON.parse(body);
        if (status === 200 || status === 201) {
          handleCloseAlert();
          setSnackbarMessage(response.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          getTruckList(1);
        } else {
          setSnackbarMessage(response.error);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setDeleteLoading(false);
        setTimeout(() => {
          handleSnackbarClose();
        }, 2000);
      });
  }

  const handleOpenDeleteConfirm = (id) => {
    setSelectDocument(id);
    setOpenAlertModal(true);
  };

  const handleDownloadFile = async (fileUrl) => {
    console.log('🚀 ~ handleDownloadFile ~ fileUrl:', fileUrl);
    if (!fileUrl) return console.log('No file URL provided');

    try {
      const response = await fetch(fileUrl, { mode: 'cors' });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileUrl.split('/').pop() || 'file');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('❌ Download failed:', error);
    }
  };

  return (
    <Page title={`Upload Document  | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack
          display="flex"
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={2}
        >
          <Stack display="flex" direction="row" alignItems="center" justifyContent="flex-start">
            <IconButton
              style={{
                marginRight: 12,
                height: 40,
                width: 70,
                borderRadius: 5,
                backgroundColor: 'rgba(209,209,209,0.3)'
              }}
              onClick={() => navigate(-1)}
            >
              <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#010f58' }} />
            </IconButton>
            <Typography variant="h4" sx={{ color: '#010f58' }}>
              Upload Document
            </Typography>
          </Stack>
          <Button
            variant="contained"
            onClick={handleOpenUploadDialog}
            startIcon={<Iconify icon="fluent:document-add-16-regular" style={{ fontSize: 19 }} />}
            sx={{ fontSize: 11 }}
          >
            Add Document
          </Button>
        </Stack>

        <Box
          style={{
            flexDirection: 'column',
            display: 'flex',
            flex: 1,
            marginTop: 10
          }}
          className="top_column"
        >
          <Box
            style={{
              flexDirection: 'row',
              display: 'flex',
              flex: 1
            }}
            className="top_column"
          >
            <Searchbar
              width={'100%'}
              fullWidth
              setFunction={(val) => {
                setsearch(val);
              }}
              className="width_full_property"
              placeholder={'Search Document'}
              onEnter={() => {
                setsearchLoading(true);
                trucksList.length = 0;
                getTruckList();
              }}
            />
            <LoadingButton
              style={{ width: '15%', marginLeft: '2.5%' }}
              variant="contained"
              className="width_full_status"
              loading={searchLoading}
              onClick={() => {
                setsearchLoading(true);
                setPage(1);
                getTruckList(1);
              }}
            >
              <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
            </LoadingButton>
          </Box>
        </Box>

        <Card sx={{ mb: 2, mt: 2, borderRadius: 1, boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)' }}>
          <CardContent>
            <Typography variant="h6" align="left" gutterBottom>
              Company Name:{' '}
              {shipmentDetail?.company?.company
                ? shipmentDetail?.company?.company
                : shipmentDetail?.company?.first_name + ' ' + shipmentDetail?.company?.last_name ||
                  'DFRR'}
            </Typography>
            <Typography variant="h6" align="left">
              Reference: {shipmentDetail?.reference_id || 'asdr@hxv.com'}
            </Typography>
          </CardContent>
        </Card>

        <TableContainer
          component={Paper}
          sx={{ boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>User Name</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>Name</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>View</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>CREATED AT</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>ACTION</TableCell>
              </TableRow>
            </TableHead>
            {!loading && (
              <TableBody>
                {trucksList.map((truck, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell>
                        <Typography style={{ fontSize: 12 }}>{truck?.user_name}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography style={{ fontSize: 12 }}>{truck?.name}</Typography>
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="outlined"
                          size="small"
                          startIcon={<VisibilityIcon />}
                          onClick={() => window.open(truck?.url, '_blank')}
                          sx={{ marginRight: 2 }}
                        >
                          View
                        </Button>
                        <Button
                          variant="outlined"
                          size="small"
                          startIcon={<DownloadIcon />}
                          // onClick={() => handleDownloadFile(truck?.url)}
                          onClick={() => handleDownloadFile(truck?.url)}
                        >
                          Download
                        </Button>
                      </TableCell>

                      <TableCell>
                        <Typography style={{ fontSize: 12, width: 75 }}>
                          {moment(truck?.created_at).format('MM/DD/YYYY')}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <IconButton
                          edge="end"
                          aria-label="delete"
                          onClick={() => {
                            handleOpenDeleteConfirm(truck?.id);
                          }}
                        >
                          <DeleteIcon style={{ color: 'red' }} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            )}

            {/* loader */}
            {loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}

            {/* empty list */}
            {trucksList.length == 0 && !loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      height="60vh"
                    >
                      <img
                        src={Empty_Truck}
                        alt="No Trucks"
                        style={{ width: '150px', marginBottom: '20px', marginRight: 40 }}
                      />
                      <Typography variant="h5" gutterBottom>
                        You haven't added any document yet
                      </Typography>
                      <Typography variant="body1" color="textSecondary" gutterBottom>
                        Add Document details that can be used to save time when creating new posts.
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>

        {/* Pagination */}
        {!loading && pagesCount > 1 && trucksList.length !== 0 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 20,
              alignItems: 'center',
              marginBottom: 20
            }}
          >
            <Pagination
              color="primary"
              shape="rounded"
              page={page}
              size="small"
              count={pagesCount}
              onChange={handlePageChange}
              renderItem={(item) => <PaginationItem {...item} />}
            />
          </Box>
        )}

        <Dialog
          open={openAlertModal}
          onClose={handleCloseAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{'Confirmation'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to proceed?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAlert} color="primary">
              No
            </Button>
            <LoadingButton
              variant="contained"
              loading={deleteLoading}
              onClick={() => {
                handleDeleteDocument();
              }}
              color="primary"
              autoFocus
            >
              Yes
            </LoadingButton>
          </DialogActions>
        </Dialog>

        <Dialog open={openUploadDialog} onClose={handleCloseUploadDialog} fullWidth>
          <DialogTitle>Upload Document</DialogTitle>
          <DialogContent>
            <TextField
              sx={{ mt: 1, mb: 2 }}
              select
              label="Document Type"
              value={documentType}
              onChange={(e) => setDocumentType(e.target.value)}
              fullWidth
              InputLabelProps={{
                shrink: true, // Force the label to shrink when a value is selected
                style: {
                  fontSize: '11px',
                  lineHeight: '1.2',
                  transform: 'translate(14px, -6px) scale(1)' // Adjust position of label
                }
              }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      paddingTop: 0 // Ensure the dropdown aligns properly
                    }
                  }
                }
              }}
              InputProps={{
                style: {
                  fontSize: 14,
                  height: '50px', // Set the height of the input field
                  padding: '0px 0px' // Add padding to input field
                }
              }}
            >
              {documentTypeList.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <input
              type="file"
              //   multiple
              onChange={handleFileChange}
              style={{ display: 'none' }}
              id="file-upload"
            />
            <label
              htmlFor="file-upload"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #010f58',
                padding: '10px',
                borderRadius: '5px',
                cursor: 'pointer',
                borderStyle: 'dashed',
                height: '80px',
                backgroundColor: '#f5f5f5'
              }}
            >
              <UploadIcon sx={{ fontSize: 50, color: '#010f58' }} />
            </label>
            <List>
              {selectedFiles?.map((file, index) => (
                <ListItem
                  key={index}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    height: 35,
                    alignItems: 'center'
                  }}
                >
                  <ListItemText primary={file.name} sx={{ height: 30, fontSize: 15 }} />
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    onClick={() => handleRemoveFile(index)}
                  >
                    <DeleteIcon style={{ color: 'red' }} />
                  </IconButton>
                </ListItem>
              ))}
            </List>
          </DialogContent>
          <DialogActions style={{ marginBottom: 10, marginRight: 10 }}>
            <Button onClick={handleCloseUploadDialog} color="primary">
              Cancel
            </Button>
            <LoadingButton
              onClick={handleSubmit}
              color="primary"
              variant="contained"
              disabled={selectedFiles.length === 0}
              loading={loadingUpload}
            >
              Submit
            </LoadingButton>
          </DialogActions>
        </Dialog>

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
